import React, { memo } from 'react'
import { SmartPhoneToggle } from 'components/atoms/icons'
import { IDriver } from 'apps/fleet-planner/types'

export interface ILoadSubscribersDriver {
  drivers: IDriver[]
  onClick: () => void
  onCancel: () => void
}

const DRIVER_SUBTEXT_ENABLED = 'Request updates via text.'
const DRIVER_SUBTEXT_DISABLED = 'Enable driver status updates'

export const DriverStatusRow = memo<ILoadSubscribersDriver>(({ drivers = [], onClick }) => {
  const countDrivers = drivers.length
  const [driver1, driver2] = drivers || []

  const {
    cellPhoneIsTwilioSubscribed: d1Twilio,
    firstName: d1FirstName,
    name: d1ImportedName,
    settings: d1Settings,
  } = driver1 || {}
  const {
    cellPhoneIsTwilioSubscribed: d2Twilio,
    firstName: d2FirstName,
    name: d2ImportedName,
    settings: d2Settings,
  } = driver2 || {}

  // Imported loads have driver names, but not driver first names
  const d1Name = d1FirstName || d1ImportedName
  const d2Name = d2FirstName || d2ImportedName

  const isD1StatusUpdatesEnabled = d1Settings?.smsStatusUpdatesEnabled && d1Twilio
  const isD2StatusUpdatesEnabled = d2Settings?.smsStatusUpdatesEnabled && d2Twilio
  const isStatusUpdatedEnabled = isD1StatusUpdatesEnabled || isD2StatusUpdatesEnabled

  const getDriverName = (): string => {
    if (isD1StatusUpdatesEnabled && isD2StatusUpdatesEnabled) {
      return `${d1FirstName} & ${d2Name}`
    }
    if (isD1StatusUpdatesEnabled) {
      return d1Name || ''
    }
    if (isD2StatusUpdatesEnabled) {
      return d2Name || ''
    }
    return ''
  }

  const getDriverText = (): string => {
    if (countDrivers === 1) {
      return isD1StatusUpdatesEnabled
        ? `Ask ${d1Name} for status updates`
        : `Don't ask ${d1Name} for status updates`
    }
    if (countDrivers === 2 && isStatusUpdatedEnabled) {
      return `Ask ${getDriverName()} for status updates`
    }
    return `Don't ask drivers for status updates`
  }

  return (
    <div className='flex'>
      <div className='flex-shrink mt1 items-center'>
        <SmartPhoneToggle isEnabled={isStatusUpdatedEnabled} />
      </div>
      <div className='flex-auto pl3 body-semibold'>
        {getDriverText()}
        {countDrivers > 0 && (
          <p className='subscribers-row-subtext'>
            {isStatusUpdatedEnabled ? (
              <span>
                {DRIVER_SUBTEXT_ENABLED}{' '}
                <button className='btn-text-link-b' onClick={onClick}>
                  Change
                </button>
              </span>
            ) : (
              <button className='btn-text-link-b' onClick={onClick}>
                {DRIVER_SUBTEXT_DISABLED}
              </button>
            )}
          </p>
        )}
      </div>
    </div>
  )
})
